import ModalViewModel, {
  ModalViewModelClosingSignal,
} from 'infra/ModalViewModel'
import OCRScopingJobBulkActionViewModel from '../../SidePanel/OCRScopingJobBulkActionViewModel'

/**
 * Modal to show the progress of the bulk action.
 */
export default class OCRBulkProgressModalViewModel extends ModalViewModel {
  constructor(
    public readonly ocrScopingJobBulkActionViewModel: OCRScopingJobBulkActionViewModel,
    closingSignal?: ModalViewModelClosingSignal,
  ) {
    super(closingSignal)
  }

  cancel = () => {
    this.ocrScopingJobBulkActionViewModel.setBulkProcessWasCancelled(true)
  }
}
